// Texty lightboxu galerie produktu (galleryLightbox.js).
import { NBSP } from '../../modules/money.js';

export default {
  dialog: 'Galerie produktu',
  close: 'Zavřít galerii',
  prev: 'Předchozí fotka',
  next: 'Další fotka',
  cart: 'Do košíku',
  allPhotos: 'Všechny fotky',
  back: 'Zpět na detail produktu',
  photo: 'Fotka',
  hint: 'Táhnutím posouváte · double-tap zpět na 1' + NBSP + '×',
};
